export const SCREENS = {
  INTRO: "intro",
  QUESTION: "question",
  AWAITING_EVALUATION: "awaiting_evaluation",
  RESULTS: "results",
  GRADING_ERROR: "grading_error",
};

// Locked intro states shared between the orchestrator (which derives them) and the
// intro screen (which renders them). Values double as the locked-state testid suffix.
export const LOCKED_STATES = {
  COMPLETE: "complete",
  EXHAUSTED: "exhausted",
};

// Machine-readable codes returned alongside 409 conflicts from the start-attempt and
// regrade endpoints, and as the code of a non-retryable grading error. The orchestrator
// switches on these instead of matching localized error messages.
export const ATTEMPT_CONFLICT_CODES = {
  ALREADY_PASSED: "already_passed",
  ATTEMPTS_EXHAUSTED: "attempts_exhausted",
};

// AssessmentAttempt.status values from the server. An in-progress attempt resumes
// the questions. awaiting_evaluation means grading is still in flight. error is a
// grading failure the learner returns to; retry comes from regrade_href unless the
// error sets retryable to false. A graded attempt resumes only with result_href.
export const ATTEMPT_STATUS = {
  IN_PROGRESS: "in_progress",
  AWAITING_EVALUATION: "awaiting_evaluation",
  GRADED: "graded",
  ERROR: "error",
};

// Grading failure codes the error screen has copy for, keyed by these strings.
// already_passed and attempts_exhausted (ATTEMPT_CONFLICT_CODES) are routed away instead.
// Whether the learner can retry comes from error.retryable and regrade_href, not the code.
export const GRADING_ERROR_CODES = {
  GRADING_RETRYABLE: "grading_retryable",
  GRADING_UNAVAILABLE: "grading_unavailable",
};

export const GRADE_STYLES = {
  NEEDS_IMPROVEMENT: {
    label: "Needs Improvement",
    color: "#BA0517",
    icon: "close",
  },
  MOSTLY_MEETS_EXPECTATIONS: {
    label: "Mostly Meets Expectations",
    color: "#9A5B00",
    icon: "choice",
  },
  FULLY_MEETS_EXPECTATIONS: {
    label: "Fully Meets Expectations",
    color: "#2E844A",
    icon: "check",
  },
  EXCEEDS_EXPECTATIONS: {
    label: "Exceeds Expectations",
    color: "#032D60",
    icon: "favorite",
  },
};

export const GRADE_LABEL_KEYS = {
  NEEDS_IMPROVEMENT: "grade_needs_improvement",
  MOSTLY_MEETS_EXPECTATIONS: "grade_mostly_meets",
  FULLY_MEETS_EXPECTATIONS: "grade_meets",
  EXCEEDS_EXPECTATIONS: "grade_exceeds",
};

export const DEFAULT_GRADE_STYLE = {
  label: "Unknown",
  color: "#032D60",
  icon: "info",
};

export const GRADING_STATUS = {
  COMPLETE: "COMPLETE",
  PENDING: "PENDING",
};

export const QUESTION_TYPES = {
  MCQ: "MCQ",
  SAQ: "SAQ",
};

// The kinds of preview an assessment can be shown in. What Retry does on a grading error
// differs between them: an author preview posts the same answers again, a learner preview
// starts over with a new draw.
export const PREVIEW_TYPES = {
  AUTHOR: "author",
  LEARNER: "learner",
};

export const SAQ_BANDS = {
  UNANSWERED: "unanswered",
  NEEDS_IMPROVEMENT: "needs_improvement",
  MOSTLY_MEETS_EXPECTATIONS: "mostly_meets_expectations",
  FULLY_MEETS_EXPECTATIONS: "fully_meets_expectations",
  EXCEEDS_EXPECTATIONS: "exceeds_expectations",
};

export const SAQ_BAND_CONFIG = {
  [SAQ_BANDS.UNANSWERED]: {
    variant: "error",
    labelKey: "grade_no_credit",
  },
  [SAQ_BANDS.NEEDS_IMPROVEMENT]: {
    variant: "warning",
    labelKey: "grade_needs_improvement",
  },
  [SAQ_BANDS.MOSTLY_MEETS_EXPECTATIONS]: {
    variant: "warning",
    labelKey: "grade_mostly_meets",
  },
  [SAQ_BANDS.FULLY_MEETS_EXPECTATIONS]: {
    variant: "success",
    labelKey: "grade_meets",
  },
  [SAQ_BANDS.EXCEEDS_EXPECTATIONS]: {
    variant: "success",
    labelKey: "grade_exceeds",
  },
};

export const MS_PER_SECOND = 1000;
